import http from '../util/ws/wsService.js'
import EntityServise from './entityService.js';

class ResourceService extends EntityServise {
    constructor() {
        super("resource")
    }

    async getByStageTypeId(stageTypeId) {
        await this.http.get(this.routeApi + "/stage-type", { stageTypeId });
    }

    async getResourcesSameStageTypeByResourceId(resourceId) {
        let res = await this.getById(resourceId);
        if (!res.success) return [];

        return await this.http.get(this.routeApi + "/stage-type", { stageTypeId: res.data.stageTypeId, skipResourceId: resourceId });
    }

    async getStatusByResourceId(resourceId) {
        return await http.get(`resource/status/s-resource`, { resourceId });
    }

    async getAllStatus() {
        return await http.get("resource/status");
    }

    async getByEnvironmentId(environmentId, byUserAuth, setor = "") {
        return byUserAuth ? await http.get("resource/user/environment", { environmentId }) : await http.get("resource/environment", { environmentId, setor });
    }

}

export default new ResourceService()

